(function ($) {
  // Utility object which houses various useful functions
  var utils = require("./utils");

  // Global variables, caching the DOM, accessible throughout this IIFE
  var $userDetailForm = $("#userDetail"),
    $orglistMaster,
    $orglistSlaves;

  // If the above form exists...
  if ($userDetailForm.length) {
    // The two DOM endpoints being connected...
    $orglistMaster = $userDetailForm.find("#organisation.js-option-provider");

    // Bind handler for when a 'change' event occurs
    $orglistMaster.on("change", updateSlave);

    /**
     *
     * INIT
     * ------------------------------
     * If there are already 'selected' elements, assume that the page is being
     * loaded in its EDIT MODE; i.e. the server is supplying the form fields
     * with information it (the page) has previously saved (during its ADD MODE)
     *
     */
    $orglistMaster.trigger("change");
  }

  function updateSlave(e) {
    $orglistSlaves = $userDetailForm.find(
      '.js-option-consumer[data-js-option-ref="' +
        $orglistMaster.attr("id") +
        '"]',
    );
    // Fetch the lastest snapshot of the 'js-option-provider'
    var masterSelectedOrgs = $orglistMaster.find(":selected");

    // Check if there are any selected Slave <option>s
    var slavesWithSelectedOpts = getSlavesWithSelectedOpts();

    if (masterSelectedOrgs.length > 0) {
      // Feed the Slaves with the selected <option>s

      if (slavesWithSelectedOpts.length > 0) {
        // There are selected <options>s

        // preserve the selected <option>s while updating the Slave list
        populateSlaveWithSelectedMasterOpts(
          masterSelectedOrgs,
          slavesWithSelectedOpts,
        );
      } else {
        // Simply do a copy from Master to Slaves
        populateSlaveWithSelectedMasterOpts(masterSelectedOrgs);
      }
    } else {
      // Make sure that Slaves are clean, to reflect 'no Master selection'
      resetAllSlaves();
    }
  }

  function getSlavesWithSelectedOpts() {
    var _SLAVES = [],
      selectedSlaveOpts;

    $orglistSlaves.each(function (index, slave) {
      var slaveObject = { selectedOpts: null };

      selectedSlaveOpts = $(slave)
        .find(":selected")
        .get()
        .map(function (optionElement) {
          return optionElement.value;
        });

      if (selectedSlaveOpts.length > 0) {
        slaveObject = {
          selectElementIndex: index,
          selectedOpts: selectedSlaveOpts,
        };
        _SLAVES.push(slaveObject);
      }
    });

    return _SLAVES;
  }

  /**
   * Totally wipe clean, all Slaves;
   * i.e. Remove all exisiting <option>s from all Slaves
   */
  function resetAllSlaves() {
    $orglistSlaves.each(function (i, slave) {
      // Clean out the Slave completely
      clearSelectedOpts(slave);
      removeAllOpts(slave);
    });
  }

  // Clear only the selected options view
  function clearSelectedOpts(selectElement) {
    $(selectElement).val("").trigger("chosen:updated");
  }

  // Reset the 'js-option-consumers'; i.e. remove all <option> elements
  function removeAllOpts(selectElement) {
    $(selectElement).empty().trigger("chosen:updated");
  }

  // Update the 'js-option-consumers' with the selected Orgs, from the 'js-option-provider' aka 'Master'
  function populateSlaveWithSelectedMasterOpts(_masterSelectedOrgs) {
    // Totally wipe clean, all Slaves
    resetAllSlaves();

    // Then update/sync each Slave with the Master selections
    $orglistSlaves.each(function (slaveIndex, slave) {
      $(_masterSelectedOrgs).each(function (optIndex, opt) {
        $(slave)
          .append($("<option>").val(opt.value).text(opt.textContent))
          .trigger("chosen:updated");
      });
    });

    // If a second argument was supplied to this function when it was called,
    // expect it to be an Array, containing objects, each representing a Slave
    // which already has at least one <option> selected
    if (arguments.length > 1) {
      if (utils.isArrayLiteral(arguments[1])) {
        // Verify that it's an Array

        $(arguments[1]).each(function (index, selectElementObject) {
          $($orglistSlaves[selectElementObject.selectElementIndex])
            .val(selectElementObject.selectedOpts)
            .trigger("chosen:updated");
        });
      }
    }
  }
})(jQuery);
